import {useState, useContext, useEffect, useMemo} from 'react';
import {Dropdown, Menu} from 'antd';
import {DownOutlined, PoweroffOutlined, UserOutlined} from '@ant-design/icons';
import {ConfigStore, SessionStore} from '@/hooks';
import {
    customEnterpriseInfo,
    CustomEnterpriseInfoResultParams,
    idgateV1ProjectTextMap,
    IIdgateV1ProjectTextMapResponse,
    mergedPoliciesListApi,
} from './service';
import './headBar.less';

export default function HeadBar() {
    const config = useContext(ConfigStore);
    const header = useMemo(() => {
        return config.app.header;
    }, [config]
    );
    const [imgUrl, setImgUrl] = useState('');
    const [mergedPoliciesList, setMergedPoliciesList] = useState([]);
    const session = useContext(SessionStore);
    const [isAdmin, setIsAdmin] = useState(true);
    const [configData, setConfigData] = useState<IIdgateV1ProjectTextMapResponse>();
    // 配置文件的请求是否返回
    const [loading, setloading] = useState(true);
    function redirctManage() {
        const project = session.project;
        location.href = `/idaas/#/idaas/project/detail?projectId=${project.id}&projectName=${project.name}`;
    }
    useEffect(() => {
        (async () => {
            if (header.logo.img.indexOf('http') === 0) {
                setImgUrl(header.logo.img);
            } else {
                const url = await import(`./img/${header.logo.img}`);
                setImgUrl(url.default);
            }
        })();

    }, [config]
    );
    useEffect(() => {
        mergedPoliciesListApi({projectId: session?.project?.id, actorId: session?.user?.id}).then((res: any) => {
            setMergedPoliciesList(() => res?.result);
        });
        setIsAdmin(() => location.hostname.startsWith('admin'));
    }, []
    );
    const [configEnterprise, setConfigEnterprise] = useState({} as CustomEnterpriseInfoResultParams);
    useEffect(
        () => {
            (async () => {
                try {
                    setloading(true);
                    const res = (await customEnterpriseInfo()) as unknown as CustomEnterpriseInfoResultParams;
                    setConfigEnterprise(() => res || {});
                    const data = await idgateV1ProjectTextMap();
                    setConfigData(data);
                    const title = data?.tab_title || res.enterpriseName;
                    if (title) {
                        document.title = title;
                    }
                    const logo = data?.tab_logo || res.enterpriseIconUrl;
                    if (logo) {
                        const icon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
                        icon.href = logo;
                    }
                } catch (error) {
                    console.error(error);
                }
                setloading(false);
            })();
        },
        []
    );
    const menu = (
        <Menu>
            <Menu.Item key="person">
                {isAdmin && <a className="frame-header-menu-item_wrap" href="/idaas/personal-center">
                    <UserOutlined />
                    <span className="txt">个人中心</span>
                </a>}
            </Menu.Item>
            <Menu.Item key="logout">
                <a className="frame-header-menu-item_wrap" href="/logout">
                    <PoweroffOutlined />
                    <span className="txt">退出</span>
                </a>
            </Menu.Item>
        </Menu>
    );
    return (
        <div className="header_wrap">
            <div>
                {!loading && <a href={header.logo.link}>
                    <img
                        height={header.logo.height}
                        className="logo"
                        src={configData?.page_logo || configEnterprise.enterpriseIconUrl || imgUrl}
                        alt={header.logo.alt}
                    />
                    <span className="txt">
                        {configData?.page_title || configEnterprise.enterpriseName || header.logoTxt}
                    </span>
                </a>}
            </div>
            <div className="user-link">
                {mergedPoliciesList.length > 0 && <a onClick={redirctManage}>企业管理</a>}
            </div>
            <Dropdown overlay={menu} placement="bottomRight">
                <div className="user-wrap" onClick={e => e.preventDefault()}>
                    <div className="avatar">{ session?.user?.displayName && session?.user.displayName[0] }</div>
                    <DownOutlined />
                </div>
            </Dropdown>
        </div>
    );
}
